export default __webpack_public_path__ + "static/img_articolo_settembre1-7333f93520626f33f8a5da0098f9b051.jpg";